// Api Calling
export const CLEAR_API_CALL_STATUS = "CLEAR_API_CALL_STATUS";
export const CLEAR_LOADING_INDICATOR = "CLEAR_LOADING_INDICATOR";

// app
export const SET_BASENAME = "SET_BASENAME";
export const GET_BASENAME = "GET_BASENAME";

// login
export const SET_USER_ID = "SET_USER_ID";
export const SET_USER_PW = "SET_USER_PW";
export const GET_USER_INFO = "GET_USER_INFO";

export const FETCH_CHECKIP_REQUEST = "FETCH_CHECKIP_REQUEST";
export const FETCH_CHECKIP_SUCCESS = "FETCH_CHECKIP_SUCCESS";
export const FETCH_CHECKIP_FAILURE = "FETCH_CHECKIP_FAILURE";

export const FETCH_LOGIN_REQUEST = "FETCH_LOGIN_REQUEST";
export const FETCH_LOGIN_SUCCESS = "FETCH_LOGIN_SUCCESS";
export const FETCH_LOGIN_FAILURE = "FETCH_LOGIN_FAILURE";

export const FETCH_LOGOUT_REQUEST = "FETCH_LOGOUT_REQUEST";
export const FETCH_LOGOUT_SUCCESS = "FETCH_LOGOUT_SUCCESS";
export const FETCH_LOGOUT_FAILURE = "FETCH_LOGOUT_FAILURE";

// I18N
export const FETCH_I18N_LANGUAGE_REQUEST = "FETCH_I18N_LANGUAGE_REQUEST";
export const FETCH_I18N_LANGUAGE_SUCCESS = "FETCH_I18N_LANGUAGE_SUCCESS";
export const FETCH_I18N_LANGUAGE_FAILURE = "FETCH_I18N_LANGUAGE_FAILURE";

// account
export const SET_ACCOUNT_ERRORLABEL = "SET_ACCOUNT_ERRORLABEL";

export const FETCH_GET_ACCOUNT_INFO_REQUEST = "FETCH_GET_ACCOUNT_INFO_REQUEST";
export const FETCH_GET_ACCOUNT_INFO_SUCCESS = "FETCH_GET_ACCOUNT_INFO_SUCCESS";
export const FETCH_GET_ACCOUNT_INFO_FAILURE = "FETCH_GET_ACCOUNT_INFO_FAILURE";

export const FETCH_GET_ACCOUNT_LANGUAGE_REQUEST = "FETCH_GET_ACCOUNT_LANGUAGE_REQUEST";
export const FETCH_GET_ACCOUNT_LANGUAGE_SUCCESS = "FETCH_GET_ACCOUNT_LANGUAGE_SUCCESS";
export const FETCH_GET_ACCOUNT_LANGUAGE_FAILURE = "FETCH_GET_ACCOUNT_LANGUAGE_FAILURE";

export const FETCH_SET_ACCOUNT_CHANGE_USERID_REQUEST = "FETCH_SET_ACCOUNT_CHANGE_USERID_REQUEST";
export const FETCH_SET_ACCOUNT_CHANGE_USERID_SUCCESS = "FETCH_SET_ACCOUNT_CHANGE_USERID_SUCCESS";
export const FETCH_SET_ACCOUNT_CHANGE_USERID_FAILURE = "FETCH_SET_ACCOUNT_CHANGE_USERID_FAILURE";

export const FETCH_SET_ACCOUNT_CHANGE_PASSWORD_REQUEST = "FETCH_SET_ACCOUNT_CHANGE_PASSWORD_REQUEST";
export const FETCH_SET_ACCOUNT_CHANGE_PASSWORD_SUCCESS = "FETCH_SET_ACCOUNT_CHANGE_PASSWORD_SUCCESS";
export const FETCH_SET_ACCOUNT_CHANGE_PASSWORD_FAILURE = "FETCH_SET_ACCOUNT_CHANGE_PASSWORD_FAILURE";

// license
export const SET_LICENSE_UPDATE_ERRORLABEL = "SET_LICENSE_UPDATE_ERRORLABEL"
export const SET_LICENSE_UPDATE_MODAL = "SET_LICENSE_UPDATE_MODAL"

export const FETCH_GET_LICENSE_INFO_REQUEST = "FETCH_GET_LICENSE_INFO_REQUEST";
export const FETCH_GET_LICENSE_INFO_SUCCESS = "FETCH_GET_LICENSE_INFO_SUCCESS";
export const FETCH_GET_LICENSE_INFO_FAILURE = "FETCH_GET_LICENSE_INFO_FAILURE";

export const FETCH_SET_LICENSE_UPDATE_REQUEST = "FETCH_SET_LICENSE_UPDATE_REQUEST";
export const FETCH_SET_LICENSE_UPDATE_SUCCESS = "FETCH_SET_LICENSE_UPDATE_SUCCESS";
export const FETCH_SET_LICENSE_UPDATE_FAILURE = "FETCH_SET_LICENSE_UPDATE_FAILURE";

export const FETCH_EXPORT_DATA_REQUEST = "FETCH_EXPORT_DATA_REQUEST";
export const FETCH_EXPORT_DATA_SUCCESS = "FETCH_EXPORT_DATA_SUCCESS";
export const FETCH_EXPORT_DATA_FAILURE = "FETCH_EXPORT_DATA_FAILURE";

export const FETCH_MANUAL_AUTH_REQUEST = "FETCH_MANUAL_AUTH_REQUEST";
export const FETCH_MANUAL_AUTH_SUCCESS = "FETCH_MANUAL_AUTH_SUCCESS";
export const FETCH_MANUAL_AUTH_FAILURE = "FETCH_MANUAL_AUTH_FAILURE";
export const SET_LAST_AUTH_TIME = "SET_LAST_AUTH_TIME";

// adapter
export const FETCH_ADAPTER_ERROR_SUCCESS = "FETCH_ADAPTER_ERROR_SUCCESS";
export const FETCH_ADAPTER_ERROR_FAILURE = "FETCH_ADAPTER_ERROR_FAILURE";

export const FETCH_GET_ADAPTER_LIST_REQUEST = "FETCH_GET_ADAPTER_LIST_REQUEST";
export const FETCH_GET_ADAPTER_LIST_SUCCESS = "FETCH_GET_ADAPTER_LIST_SUCCESS";
export const FETCH_GET_ADAPTER_LIST_FAILURE = "FETCH_GET_ADAPTER_LIST_FAILURE";

export const FETCH_SET_ADAPTER_UNREGISTER_REQUEST = "FETCH_SET_ADAPTER_UNREGISTER_REQUEST"
export const FETCH_SET_ADAPTER_UNREGISTER_SUCCESS = "FETCH_SET_ADAPTER_UNREGISTER_SUCCESS"
export const FETCH_SET_ADAPTER_UNREGISTER_FAILURE = "FETCH_SET_ADAPTER_UNREGISTER_FAILURE"

export const FETCH_SET_ADAPTER_ENABLE_REQUEST = "FETCH_SET_ADAPTER_ENABLE_REQUEST"
export const FETCH_SET_ADAPTER_ENABLE_SUCCESS = "FETCH_SET_ADAPTER_ENABLE_SUCCESS"
export const FETCH_SET_ADAPTER_ENABLE_FAILURE = "FETCH_SET_ADAPTER_ENABLE_FAILURE"

// adapter Register
export const SET_ADAPTER_REGISTER_ERRORLABEL = "SET_ADAPTER_REGISTER_ERRORLABEL"
export const SET_ADAPTER_REGISTER_MODAL = "SET_ADAPTER_REGISTER_MODAL"

export const FETCH_SET_ADAPTER_REGISTER_REQUEST = "FETCH_SET_ADAPTER_REGISTER_REQUEST"
export const FETCH_SET_ADAPTER_REGISTER_SUCCESS = "FETCH_SET_ADAPTER_REGISTER_SUCCESS"
export const FETCH_SET_ADAPTER_REGISTER_FAILURE = "FETCH_SET_ADAPTER_REGISTER_FAILURE"

// adapter update
export const SET_ADAPTER_UPDATE_ERRORLABEL = "SET_ADAPTER_UPDATE_ERRORLABEL"
export const SET_ADAPTER_UPDATE_MODAL = "SET_ADAPTER_UPDATE_MODAL"

export const FETCH_SET_ADAPTER_UPDATE_REQUEST = "FETCH_SET_ADAPTER_UPDATE_REQUEST"
export const FETCH_SET_ADAPTER_UPDATE_SUCCESS = "FETCH_SET_ADAPTER_UPDATE_SUCCESS"
export const FETCH_SET_ADAPTER_UPDATE_FAILURE = "FETCH_SET_ADAPTER_UPDATE_FAILURE"

// adapter setting
export const SET_ADAPTER_SETTING_ERRORLABEL = "SET_ADAPTER_SETTING_ERRORLABEL"
export const SET_ADAPTER_SETTING_MODAL = "SET_ADAPTER_SETTING_MODAL"

export const SET_ADAPTER_SETTING_STORAGENAME = "SET_ADAPTER_SETTING_STORAGENAME"
export const SET_ADAPTER_SETTING_PARAMSNAME = "SET_ADAPTER_SETTING_PARAMSNAME"
export const SET_ADAPTER_SETTING_ROOTNAME = "SET_ADAPTER_SETTING_ROOTNAME"
export const SET_ADAPTER_SETTING_ROOTPATH = "SET_ADAPTER_SETTING_ROOTPATH"

export const FETCH_GET_ADAPTER_SETTING_REQUEST = "FETCH_GET_ADAPTER_SETTING_REQUEST"
export const FETCH_GET_ADAPTER_SETTING_SUCCESS = "FETCH_GET_ADAPTER_SETTING_SUCCESS"
export const FETCH_GET_ADAPTER_SETTING_FAILURE = "FETCH_GET_ADAPTER_SETTING_FAILURE"

export const FETCH_SET_ADAPTER_STORAGE_REQUEST = "FETCH_SET_ADAPTER_STORAGE_REQUEST"
export const FETCH_SET_ADAPTER_STORAGE_SUCCESS = "FETCH_SET_ADAPTER_STORAGE_SUCCESS"
export const FETCH_SET_ADAPTER_STORAGE_FAILURE = "FETCH_SET_ADAPTER_STORAGE_FAILURE"

export const FETCH_SET_ADAPTER_PARAMS_REQUEST = "FETCH_SET_ADAPTER_PARAMS_REQUEST"
export const FETCH_SET_ADAPTER_PARAMS_SUCCESS = "FETCH_SET_ADAPTER_PARAMS_SUCCESS"
export const FETCH_SET_ADAPTER_PARAMS_FAILURE = "FETCH_SET_ADAPTER_PARAMS_FAILURE"

export const FETCH_SET_ADAPTER_ROOTPATH_REQUEST = "FETCH_SET_ADAPTER_ROOTPATH_REQUEST"
export const FETCH_SET_ADAPTER_ROOTPATH_SUCCESS = "FETCH_SET_ADAPTER_ROOTPATH_SUCCESS"
export const FETCH_SET_ADAPTER_ROOTPATH_FAILURE = "FETCH_SET_ADAPTER_ROOTPATH_FAILURE"

// uniAdapter
export const SET_INTERFACE_RESPONSE_SOURCE = "SET_INTERFACE_RESPONSE_SOURCE"
export const SET_INTERFACE_IS_REQUEST_ACTIVE = "SET_INTERFACE_IS_REQUEST_ACTIVE"

export const FETCH_GET_SAMPLE_WEBOFFICE_URL_REQUEST = "FETCH_GET_SAMPLE_WEBOFFICE_URL_REQUEST"
export const FETCH_GET_SAMPLE_WEBOFFICE_URL_SUCCESS = "FETCH_GET_SAMPLE_WEBOFFICE_URL_SUCCESS"
export const FETCH_GET_SAMPLE_WEBOFFICE_URL_FAILURE = "FETCH_GET_SAMPLE_WEBOFFICE_URL_FAILURE"

export const FETCH_SET_SAMPLE_WEBOFFICE_URL_REQUEST = "FETCH_SET_SAMPLE_WEBOFFICE_URL_REQUEST"
export const FETCH_SET_SAMPLE_WEBOFFICE_URL_SUCCESS = "FETCH_SET_SAMPLE_WEBOFFICE_URL_SUCCESS"
export const FETCH_SET_SAMPLE_WEBOFFICE_URL_FAILURE = "FETCH_SET_SAMPLE_WEBOFFICE_URL_FAILURE"

export const FETCH_SET_RESET_UNIADAPTER_INTERFACE_REQUEST = "FETCH_SET_RESET_UNIADAPTER_INTERFACE_REQUEST"
export const FETCH_SET_RESET_UNIADAPTER_INTERFACE_SUCCESS = "FETCH_SET_RESET_UNIADAPTER_INTERFACE_SUCCESS"
export const FETCH_SET_RESET_UNIADAPTER_INTERFACE_FAILURE = "FETCH_SET_RESET_UNIADAPTER_INTERFACE_FAILURE"

export const FETCH_GET_UNIADAPTER_ACTIVE_STATUS_REQUEST = "FETCH_GET_UNIADAPTER_ACTIVE_STATUS_REQUEST"
export const FETCH_GET_UNIADAPTER_ACTIVE_STATUS_SUCCESS = "FETCH_GET_UNIADAPTER_ACTIVE_STATUS_SUCCESS"
export const FETCH_GET_UNIADAPTER_ACTIVE_STATUS_FAILURE = "FETCH_GET_UNIADAPTER_ACTIVE_STATUS_FAILURE"

export const FETCH_GET_UNIADAPTER_HTTP_EXECUTE_REQUEST = "FETCH_GET_UNIADAPTER_HTTP_EXECUTE_REQUEST"
export const FETCH_GET_UNIADAPTER_HTTP_EXECUTE_SUCCESS = "FETCH_GET_UNIADAPTER_HTTP_EXECUTE_SUCCESS"
export const FETCH_GET_UNIADAPTER_HTTP_EXECUTE_FAILURE = "FETCH_GET_UNIADAPTER_HTTP_EXECUTE_FAILURE"

export const FETCH_GET_UNIADAPTER_PARAMETER_REQUEST = "FETCH_GET_UNIADAPTER_PARAMETER_REQUEST"
export const FETCH_GET_UNIADAPTER_PARAMETER_SUCCESS = "FETCH_GET_UNIADAPTER_PARAMETER_SUCCESS"
export const FETCH_GET_UNIADAPTER_PARAMETER_FAILURE = "FETCH_GET_UNIADAPTER_PARAMETER_FAILURE"

export const FETCH_SET_UNIADAPTER_PARAMETER_REQUEST = "FETCH_SET_UNIADAPTER_PARAMETER_REQUEST"
export const FETCH_SET_UNIADAPTER_PARAMETER_SUCCESS = "FETCH_SET_UNIADAPTER_PARAMETER_SUCCESS"
export const FETCH_SET_UNIADAPTER_PARAMETER_FAILURE = "FETCH_SET_UNIADAPTER_PARAMETER_FAILURE"

export const FETCH_SET_UNIADAPTER_START_REQUEST = "FETCH_SET_UNIADAPTER_START_REQUEST"
export const FETCH_SET_UNIADAPTER_START_SUCCESS = "FETCH_SET_UNIADAPTER_START_SUCCESS"
export const FETCH_SET_UNIADAPTER_START_FAILURE = "FETCH_SET_UNIADAPTER_START_FAILURE"

export const FETCH_GET_UNIADAPTER_INTERFACE_REQUEST = "FETCH_GET_UNIADAPTER_INTERFACE_REQUEST"
export const FETCH_GET_UNIADAPTER_INTERFACE_SUCCESS = "FETCH_GET_UNIADAPTER_INTERFACE_SUCCESS"
export const FETCH_GET_UNIADAPTER_INTERFACE_FAILURE = "FETCH_GET_UNIADAPTER_INTERFACE_FAILURE"

export const FETCH_SET_UNIADAPTER_INTERFACE_REQUEST = "FETCH_SET_UNIADAPTER_INTERFACE_REQUEST"
export const FETCH_SET_UNIADAPTER_INTERFACE_SUCCESS = "FETCH_SET_UNIADAPTER_INTERFACE_SUCCESS"
export const FETCH_SET_UNIADAPTER_INTERFACE_FAILURE = "FETCH_SET_UNIADAPTER_INTERFACE_FAILURE"

export const FETCH_GET_UNIADAPTER_LIST_REQUEST = "FETCH_GET_UNIADAPTER_LIST_REQUEST"
export const FETCH_GET_UNIADAPTER_LIST_SUCCESS = "FETCH_GET_UNIADAPTER_LIST_SUCCESS"
export const FETCH_GET_UNIADAPTER_LIST_FAILURE = "FETCH_GET_UNIADAPTER_LIST_FAILURE"

export const FETCH_GET_UNIADAPTER_EXPORT_REQUEST = "FETCH_GET_UNIADAPTER_EXPORT_REQUEST"
export const FETCH_GET_UNIADAPTER_EXPORT_SUCCESS = "FETCH_GET_UNIADAPTER_EXPORT_SUCCESS"
export const FETCH_GET_UNIADAPTER_EXPORT_FAILURE = "FETCH_GET_UNIADAPTER_EXPORT_FAILURE"

export const FETCH_SET_UNIADAPTER_IMPORT_REQUEST = "FETCH_SET_UNIADAPTER_IMPORT_REQUEST"
export const FETCH_SET_UNIADAPTER_IMPORT_SUCCESS = "FETCH_SET_UNIADAPTER_IMPORT_SUCCESS"
export const FETCH_SET_UNIADAPTER_IMPORT_FAILURE = "FETCH_SET_UNIADAPTER_IMPORT_FAILURE"

export const FETCH_GET_UNIADAPTER_CONNECT_PARAMETERS_REQUEST = "FETCH_GET_UNIADAPTER_CONNECT_PARAMETERS_REQUEST"
export const FETCH_GET_UNIADAPTER_CONNECT_PARAMETERS_SUCCESS = "FETCH_GET_UNIADAPTER_CONNECT_PARAMETERS_SUCCESS"
export const FETCH_GET_UNIADAPTER_CONNECT_PARAMETERS_FAILURE = "FETCH_GET_UNIADAPTER_CONNECT_PARAMETERS_FAILURE"

export const FETCH_SET_UNIADAPTER_CONNECT_PARAMETERS_REQUEST = "FETCH_SET_UNIADAPTER_CONNECT_PARAMETERS_REQUEST"
export const FETCH_SET_UNIADAPTER_CONNECT_PARAMETERS_SUCCESS = "FETCH_SET_UNIADAPTER_CONNECT_PARAMETERS_SUCCESS"
export const FETCH_SET_UNIADAPTER_CONNECT_PARAMETERS_FAILURE = "FETCH_SET_UNIADAPTER_CONNECT_PARAMETERS_FAILURE"

// stats
export const SET_STATS_ERRORLABEL = "SET_STATS_ERRORLABEL"
export const SET_STATS_OPTION_PERIOD = "SET_STATS_OPTION_PERIOD"
export const SET_STATS_STARTDATE = "SET_STATS_STARTDATE"
export const SET_STATS_ENDTDATE = "SET_STATS_ENDTDATE"
export const SET_STATS_CONDITION = "SET_STATS_CONDITION"
export const SET_STATS_SUMMARY_TOTAL = "SET_STATS_SUMMARY_TOTAL"

export const FETCH_GET_STATS_SUMMARY_INFO_REQUEST = "FETCH_GET_STATS_SUMMARY_INFO_REQUEST"
export const FETCH_GET_STATS_SUMMARY_INFO_SUCCESS = "FETCH_GET_STATS_SUMMARY_INFO_SUCCESS"
export const FETCH_GET_STATS_SUMMARY_INFO_FAILURE = "FETCH_GET_STATS_SUMMARY_INFO_FAILURE"

export const FETCH_GET_STATS_SUMMARY_CSV_REQUEST = "FETCH_GET_STATS_SUMMARY_CSV_REQUEST"
export const FETCH_GET_STATS_SUMMARY_CSV_SUCCESS = "FETCH_GET_STATS_SUMMARY_CSV_SUCCESS"
export const FETCH_GET_STATS_SUMMARY_CSV_FAILURE = "FETCH_GET_STATS_SUMMARY_CSV_FAILURE"

// setting
export const FETCH_GET_SETTING_GROUPID_INFO_REQUEST = "FETCH_GET_SETTING_GROUPID_INFO_REQUEST"
export const FETCH_GET_SETTING_GROUPID_INFO_SUCCESS = "FETCH_GET_SETTING_GROUPID_INFO_SUCCESS"
export const FETCH_GET_SETTING_GROUPID_INFO_FAILURE = "FETCH_GET_SETTING_GROUPID_INFO_FAILURE"

export const FETCH_GET_SETTING_INFO_REQUEST = "FETCH_GET_SETTING_INFO_REQUEST"
export const FETCH_GET_SETTING_INFO_SUCCESS = "FETCH_GET_SETTING_INFO_SUCCESS"
export const FETCH_GET_SETTING_INFO_FAILURE = "FETCH_GET_SETTING_INFO_FAILURE"

export const SET_SETTING_DATA = "SET_SETTING_DATA"

// setting ing
export const FETCH_GET_SETTING_DATA_INFO_REQUEST = "FETCH_GET_SETTING_DATA_INFO_REQUEST"
export const FETCH_GET_SETTING_DATA_INFO_SUCCESS = "FETCH_GET_SETTING_DATA_INFO_SUCCESS"
export const FETCH_GET_SETTING_DATA_INFO_FAILURE = "FETCH_GET_SETTING_DATA_INFO_FAILURE"

export const FETCH_GET_SETTING_ADDITIONAL_DEFAULT_KEY_INFO_REQUEST = "FETCH_GET_SETTING_ADDITIONAL_DEFAULT_KEY_INFO_REQUEST"
export const FETCH_GET_SETTING_ADDITIONAL_DEFAULT_KEY_INFO_SUCCESS = "FETCH_GET_SETTING_ADDITIONAL_DEFAULT_KEY_INFO_SUCCESS"
export const FETCH_GET_SETTING_ADDITIONAL_DEFAULT_KEY_INFO_FAILURE = "FETCH_GET_SETTING_ADDITIONAL_DEFAULT_KEY_INFO_FAILURE"

export const FETCH_GET_SETTING_ADDTIONAL_LIST_REQUEST = "FETCH_GET_SETTING_ADDTIONAL_LIST_REQUEST"
export const FETCH_GET_SETTING_ADDTIONAL_LIST_SUCCESS = "FETCH_GET_SETTING_ADDTIONAL_LIST_SUCCESS"
export const FETCH_GET_SETTING_ADDTIONAL_LIST_FAILURE = "FETCH_GET_SETTING_ADDTIONAL_LIST_FAILURE"

export const FETCH_SET_SETTING_DATA_UPDATE_REQUEST = "FETCH_SET_SETTING_DATA_UPDATE_REQUEST"
export const FETCH_SET_SETTING_DATA_UPDATE_SUCCESS = "FETCH_SET_SETTING_DATA_UPDATE_SUCCESS"
export const FETCH_SET_SETTING_DATA_UPDATE_FAILURE = "FETCH_SET_SETTING_DATA_UPDATE_REQUEST"

export const FETCH_SET_SETTING_REDIS_MODE_UPDATE_REQUEST = "FETCH_SET_SETTING_REDIS_MODE_UPDATE_REQUEST"
export const FETCH_SET_SETTING_REDIS_MODE_UPDATE_SUCCESS = "FETCH_SET_SETTING_REDIS_MODE_UPDATE_SUCCESS"
export const FETCH_SET_SETTING_REDIS_MODE_UPDATE_FAILURE = "FETCH_SET_SETTING_REDIS_MODE_UPDATE_FAILURE"

export const FETCH_SET_SETTING_ADDITIONAL_DATA_REQUEST = "FETCH_SET_SETTING_ADDITIONAL_DATA_REQUEST"
export const FETCH_SET_SETTING_ADDITIONAL_DATA_SUCCESS = "FETCH_SET_SETTING_ADDITIONAL_DATA_SUCCESS"
export const FETCH_SET_SETTING_ADDITIONAL_DATA_FAILURE = "FETCH_SET_SETTING_ADDITIONAL_DATA_FAILURE"

export const SET_SETTING_ADDITIONAL_DATA = "SET_SETTING_ADDITIONAL_DATA"

// UI Customization

export const FETCH_SET_UI_CUSTOMIZATION_REQUEST = 'FETCH_SET_UI_CUSTOMIZATION_REQUEST';
export const FETCH_SET_UI_CUSTOMIZATION_SUCCESS = 'FETCH_SET_UI_CUSTOMIZATION_SUCCESS';
export const FETCH_SET_UI_CUSTOMIZATION_FAILURE = 'FETCH_SET_UI_CUSTOMIZATION_FAILURE';

export const FETCH_GET_UI_CUSTOMIZATION_REQUEST = 'FETCH_GET_UI_CUSTOMIZATION_REQUEST';
export const FETCH_GET_UI_CUSTOMIZATION_SUCCESS = 'FETCH_GET_UI_CUSTOMIZATION_SUCCESS';
export const FETCH_GET_UI_CUSTOMIZATION_FAILURE = 'FETCH_GET_UI_CUSTOMIZATION_FAILURE';

// WebFont
export const FETCH_WEBFONT_UPLOAD_REQUEST = 'FETCH_WEBFONT_UPLOAD_REQUEST';
export const FETCH_WEBFONT_UPLOAD_SUCCESS = 'FETCH_WEBFONT_UPLOAD_SUCCESS';
export const FETCH_WEBFONT_UPLOAD_FAILURE = 'FETCH_WEBFONT_UPLOAD_FAILURE';

export const FETCH_WEBFONT_LIST_REQUEST = 'FETCH_WEBFONT_LIST_REQUEST';
export const FETCH_WEBFONT_LIST_SUCCESS = 'FETCH_WEBFONT_LIST_SUCCESS';
export const FETCH_WEBFONT_LIST_FAILURE = 'FETCH_WEBFONT_LIST_FAILURE';

export const FETCH_WEBFONT_DELETE_REQUEST = 'FETCH_WEBFONT_DELETE_REQUEST';
export const FETCH_WEBFONT_DELETE_SUCCESS = 'FETCH_WEBFONT_DELETE_SUCCESS';
export const FETCH_WEBFONT_DELETE_FAILURE = 'FETCH_WEBFONT_DELETE_FAILURE';

// monitoring
export const FETCH_REALTIME_MONITORING_DATA_REQUEST = "FETCH_REALTIME_MONITORING_DATA_REQUEST"
export const FETCH_REALTIME_MONITORING_DATA_SUCCESS = "FETCH_REALTIME_MONITORING_DATA_SUCCESS"
export const FETCH_REALTIME_MONITORING_DATA_FAILURE = "FETCH_REALTIME_MONITORING_DATA_FAILURE"
export const FETCH_REALTIME_MONITORING_DATA_REQUEST_STOP = "FETCH_REALTIME_MONITORING_DATA_REQUEST_STOP"

// messageBox visible
export const FETCH_MESSAGEBOX_REQUEST = "FETCH_MESSAGEBOX_REQUEST";
export const FETCH_MESSAGEBOX_ON = "FETCH_MESSAGEBOX_ON";
export const FETCH_MESSAGEBOX_OFF = "FETCH_MESSAGEBOX_OFF";


